import React from 'react';
import { FormattedMessage } from 'react-intl';
import { StyledLink } from '../StyledComponents';
import { DetailsRow } from '../DetailsRowContentElements/DetailsRow';
import { messages } from '../../../messages';
import { ATLASSIAN_CLOUD } from '../../../../../data/products/keys';
import { isAtlassianOrganisation } from '../../../../../util/mac/helpers';

export const UpdateAddressDetailsLink = ({ productKey }: { productKey: string }) => {
  const isCloudOrOrganisation =
    productKey === ATLASSIAN_CLOUD || isAtlassianOrganisation(productKey);

  if (isCloudOrOrganisation) {
    return null;
  }

  return (
    <DetailsRow
      label={<FormattedMessage {...messages.addressDetails} />}
      value={
        <StyledLink href="my/edit-details">
          <FormattedMessage {...messages.updateAddressDetails} />
        </StyledLink>
      }
      dataCy="mac-address-details"
    />
  );
};
